import { render, staticRenderFns } from "./AdminRooms.vue?vue&type=template&id=0ac52246&"
import script from "./AdminRooms.vue?vue&type=script&lang=js&"
export * from "./AdminRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports